var path = 'dashboard/dashboard-toolbar.tpl.html';
var html = " <md-fab-toolbar md-open=vm.toolbarOpened md-direction=left ng-class=\"{'is-fullscreen': vm.forceFullscreen, 'md-whiteframe-z1': vm.forceFullscreen}\"> <md-fab-trigger class=align-with-text> <md-button aria-label=menu class=\"md-fab md-primary\" ng-click=vm.onTriggerClick()> <md-tooltip ng-show=!vm.toolbarOpened md-direction=bottom> {{ 'dashboard.open-toolbar' | translate }} </md-tooltip> <md-icon aria-label=dashboard-toolbar class=material-icons>more_horiz</md-icon> </md-button> </md-fab-trigger> <md-toolbar> <md-fab-actions class=md-toolbar-tools> <div ng-transclude></div> </md-fab-actions> </md-toolbar> </md-fab-toolbar> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard-toolbar.tpl.html
// module id = 1356
// module chunks = 1